
import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import moment from 'moment';
import { ReservationItemModule } from '@/store/modules/reservationItem';

@Component({
  components: {
  },
})
export default class extends Vue {
  @Prop({ required: true }) private selectedDayType!: string;

  private itemHours: any = [];

  private originItemHours: any = [];

  private limitDate = moment(ReservationItemModule.form.possiableUpdateDate);

  private isUpdate = false;

  mounted() {
    this.setData();
  }

  private addTimeForm() {
    const defaultHour: any = {
      startTime: '00:00',
      endTime: '00:00',
      freeStatus: false,
      price: 0,
      maxPeople: 10,
      dayType: this.selectedDayType,
    };
    this.itemHours.push(defaultHour);
  }

  private deleteCharge(index: number) {
    this.itemHours.splice(index, 1);
  }

  private setData() {
    if (ReservationItemModule.scheduleType === null && ReservationItemModule.updateScheduleDate === '0') {
      this.originItemHours = [...ReservationItemModule.form.itemHour];
      this.itemHours = ReservationItemModule.form.itemHour;
    } else if (ReservationItemModule.scheduleType === null && ReservationItemModule.updateScheduleDate !== '0') {
      this.originItemHours = [...ReservationItemModule.form.updateSchedule[Number(ReservationItemModule.updateScheduleDate) - 1].itemHour];
      this.itemHours = ReservationItemModule.form.updateSchedule[Number(ReservationItemModule.updateScheduleDate) - 1].itemHour;
      this.isUpdate = !this.limitDate.isAfter(ReservationItemModule.form.updateSchedule[Number(ReservationItemModule.updateScheduleDate) - 1].updateDate);
    } else if (ReservationItemModule.scheduleType !== null && ReservationItemModule.updateScheduleDate === '0') {
      this.originItemHours = [...ReservationItemModule.form.schedulePart[ReservationItemModule.scheduleType].itemHour];
      this.itemHours = ReservationItemModule.form.schedulePart[ReservationItemModule.scheduleType].itemHour;
    } else if (ReservationItemModule.scheduleType !== null && ReservationItemModule.updateScheduleDate !== '0') {
      this.originItemHours = [...ReservationItemModule.form.schedulePart[ReservationItemModule.scheduleType].updateSchedule[Number(ReservationItemModule.updateScheduleDate) - 1].itemHour];
      this.itemHours = ReservationItemModule.form.schedulePart[ReservationItemModule.scheduleType].updateSchedule[Number(ReservationItemModule.updateScheduleDate) - 1].itemHour;
      this.isUpdate = !this.limitDate.isAfter(ReservationItemModule.form.schedulePart[ReservationItemModule.scheduleType].updateSchedule[Number(ReservationItemModule.updateScheduleDate) - 1].updateDate);
    }
  }

  private closeDetailForm() {
    if (ReservationItemModule.scheduleType === null && ReservationItemModule.updateScheduleDate === '0') {
      ReservationItemModule.form.itemHour = this.originItemHours;
    } else if (ReservationItemModule.scheduleType === null && ReservationItemModule.updateScheduleDate !== '0') {
      ReservationItemModule.form.updateSchedule[Number(ReservationItemModule.updateScheduleDate) - 1].itemHour = this.originItemHours;
    } else if (ReservationItemModule.scheduleType !== null && ReservationItemModule.updateScheduleDate === '0') {
      ReservationItemModule.form.schedulePart[ReservationItemModule.scheduleType].itemHour = this.originItemHours;
    } else if (ReservationItemModule.scheduleType !== null && ReservationItemModule.updateScheduleDate !== '0') {
      ReservationItemModule.form.schedulePart[ReservationItemModule.scheduleType].updateSchedule[Number(ReservationItemModule.updateScheduleDate) - 1].itemHour = this.originItemHours;
    }
    this.$emit('close');
  }

  private submitDetailForm() {
    // let notValidCount = 0;
    // this.itemHours.forEach((item: any) => {
    //   if (item.timeRange == null || item.timeRange.length !== 2) notValidCount += 1;
    // });
    // if (notValidCount > 0) {
    //   this.$message.warning('시간을 입력해주세요.');
    // } else {
    //   this.$emit('close');
    //   this.$emit('submit', this.itemHours);
    // }
    this.$emit('close');
    this.$emit('submit', this.itemHours);
  }
}
